import React, { useMemo } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import useSearchBar from '@contexts/searchbar';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';

import DesktopSearchGuest from './DesktopSearchGuest';
import MobileSearchGuest from './MobileSearchGuest';

export interface IHotelSearchGuest {
  totalGuestCount: {
    adultCount: number;
    childCount: number;
  };
  onChange?(rooms: ListingSearchRoomInterface[]): void;
  value?: ListingSearchRoomInterface[];
}

const HotelSearchGuest = ({
  onChange,
  value,
}: Pick<IHotelSearchGuest, 'onChange' | 'value'>) => {
  const { xl } = useBreakpoint();
  const {
    state: { hotel: state },
  } = useSearchBar();

  const rooms = value || state.rooms;

  /**
   * This function is used to calculate adult and child guest count.
   */
  const totalGuestCount = useMemo(() => {
    let adultCount = 0;
    let childCount = 0;

    rooms.forEach((room) => {
      adultCount += room.adultCount;
    });

    childCount = rooms
      .map((room) => room.childrenList?.length || 0)
      .reduce((a: number, b: number) => a + b);

    return {
      adultCount,
      childCount,
    };
  }, [rooms]);

  return (
    <>
      {xl || xl === undefined ? (
        <DesktopSearchGuest
          onChange={onChange}
          value={rooms}
          totalGuestCount={totalGuestCount}
        />
      ) : (
        <MobileSearchGuest
          onChange={onChange}
          value={rooms}
          totalGuestCount={totalGuestCount}
        />
      )}
    </>
  );
};

export default HotelSearchGuest;
